/* eslint-disable no-return-assign */
import { BankType, BrandType, Country } from '../generated/graphql';
import { session } from './auth';
import { getEventRouterClient } from './getEventRouterClient';
import { storage } from './storage';

declare const analytics: any;

const INITIAL_REFERRER_ID = '_INITIAL_REFERRER_ID';
const referrerId = {
  set: (ref: string) => storage.setItem(INITIAL_REFERRER_ID, ref),
  get: () => ({ referrerId: storage.getItem(INITIAL_REFERRER_ID) }),
  clear: () => storage.removeItem(INITIAL_REFERRER_ID),
};

const trackingInfo = (() => {
  let bank: BankType = BankType.NoBank;
  let brand: BrandType = BrandType.Tranquiapp;
  let userId = 0;

  const setBank = (selectedBank?: BankType) => bank = selectedBank || BankType.NoBank;
  const setBrand = (selectedBrand?: BrandType) => brand = selectedBrand || BrandType.Tranquiapp;
  const setUserId = (activeUserId?: number | string) => userId = parseInt(`${activeUserId || 0}`, 10) || 0;
  const getBase = () => ({ bank, brand, country: Country.Co, userId });

  return { setBank, setBrand, setUserId, getBase };
})();

const client = getEventRouterClient({
  // TODO: move to env
  endpoint: 'https://lnq9x08opc.execute-api.us-east-1.amazonaws.com/Prod/event',
  isProd: true,
});

const track = (name: string, payload?: Record<string, any>) => client
  .track(name, { ...trackingInfo.getBase(), payload });

/**
 * Account tracking object
 */
// TODO: ACTIVATE!
const analyticsActive = (window as any).analyticsActive || false;

const account = {
  logout: () => {
    if (!analyticsActive) return;
    track('Account Logout', { ...referrerId.get() });
    analytics.track('Account Logout', { ...referrerId.get() });
    referrerId.clear();
    analytics.reset();
  },
  simple: (
    traits: { id: string, document: string },
    callback: () => void,
  ) => {
    if (analyticsActive) {
      const { id, document } = traits;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const created_at = Math.round((new Date()).getTime() / 1000);
      track('Account Identify', { id, document, created_at, delivery_id: session.deliveryId, ...referrerId.get() });
      analytics.identify(id, { document, created_at, delivery_id: session.deliveryId });
    }
    callback();
  },
  verifyPhone: (id: string, phone: any) => {
    if (!analyticsActive) return;
    track('Account VerifyPhone', { id, phone: `57${phone}`, ...referrerId.get() });
    analytics.identify(id, { phone: `57${phone}` });
  },
};

/**
 * Errors
 */
const error = {
  graphql: (message: string) => {
    if (!analyticsActive) return;
    track('Error', { ...referrerId.get(), type: 'graphql', message });
    analytics.track('Error', { ...referrerId.get(), type: 'graphql', message });
  },
  crash: (message: string) => {
    if (!analyticsActive) return;
    track('Error', { ...referrerId.get(), type: 'crash', message });
    analytics.track('Error', { ...referrerId.get(), type: 'crash', message });
  },
};

/**
 * Page tracking object
 */
const page = {
  view: () => {
    if (!analyticsActive) return;
    track('Page View', { ...referrerId.get(), delivery_id: session.deliveryId });
    analytics.page(undefined, undefined, { ...referrerId.get(), delivery_id: session.deliveryId });
  },
  external: (url: string) => {
    if (!analyticsActive) return url;
    track('Page External', { ...referrerId.get(), url });
    analytics.track('Page External', { url, ...referrerId.get() });
    return url;
  },
};

export default {
  account,
  page,
  referrerId,
  error,
  ...trackingInfo,
};
